import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Panel } from 'primereact/panel';
import ImportDefinitionListContainer from './definitions/ImportDefinitionListContainer';

export class Definition extends Component {
  render() {
    return (
      <Panel header={<FormattedMessage id="survey_import.header" defaultMessage="Survey Import" />}>
        <ImportDefinitionListContainer />
      </Panel>
    );
  }
}

export default Definition;
